import { render } from "./forgotPassword.vue?vue&type=template&id=5c5d1c32&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./forgotPassword.vue?vue&type=script&setup=true&lang=js"

import "./forgotPassword.vue?vue&type=style&index=0&id=5c5d1c32&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5d1c32"],['__file',"pages/EndataAuth/Account/App/components/profile/forgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c5d1c32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c5d1c32', __exports__)) {
    api.reload('5c5d1c32', __exports__)
  }
  
  module.hot.accept("./forgotPassword.vue?vue&type=template&id=5c5d1c32&scoped=true", () => {
    api.rerender('5c5d1c32', render)
  })

}


export default __exports__